<template>
	<div class="sign-up">
		<div class="container">
			<div class="page-container">
				<step1 v-if="currentStep === 1" @submit="handleSubmit"></step1>
				<step2 v-if="currentStep === 2"></step2>
				<step3 v-if="currentStep === 3"></step3>
			</div>
		</div>
	</div>
</template>
<script>
import step1 from "./components/step1";
import step2 from "./components/step2";
import step3 from "./components/step3";
export default {
	name: "signUp",
	data(){
		return {
			currentStep:1
		}
	},
	methods:{
		handleSubmit(form){
			this.currentStep = 2
		}
	},
	components: {
		step1,
		step2,
		step3
	}
};
</script>
<style lang="scss" scoped>
.sign-up {
	margin-top: 20px;
	.container {
		.page-container {
			width: 80%;
			margin: 0 auto;
			::v-deep.el-select {
				width: 100%;
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.sign-up {
		.container {
			.page-container {
				width: 100%;
			}
		}
	}
}
</style>
